<template>
  <div class="login">
    <HeaderTop :activeIndex="activeIndex" :is_login="is_login"></HeaderTop>
    <div class="login-bannerbox">
      <img src="../assets/banner1.png" class="bannerbox-banner">

      <div class="loginBox" @keyup.enter="dologin" >
        <b-overlay :show="loading" rounded="sm" opacity="0.5">
        <div class="loginBox-title">
          <div :class="type == 0 ? 'active title' : 'title'" @click="typeChange(0)">学生登录</div>
          <!-- <div :class="type == 1 ? 'active title' : 'title'" @click="typeChange(1)">管理员登录</div> -->
        </div>
        <div class="loginBox-input clearfix">
          <img src="../assets/home_icon18.png" class="input-icon">
          <input type="text" class="ipt" placeholder="请输入账号" v-model="form.username"/>
        </div>
        <div class="loginBox-input clearfix">
          <img src="../assets/home_icon19.png" class="input-icon">
          <input type="password" class="ipt" placeholder="请输入密码" v-model="form.password"/>
        </div>
        <button class="loginBox-loginbtn" @click="dologin">登录</button>
        <div class="loginBox-title">
          <div class="password-retrieve" @click="()=>{verificationCode();dialogVisible=true}">忘记密码，密码重置</div>
        </div>
        </b-overlay>
      </div>

    </div>
    <div class="loging-notice">
      <div class="notice-mid">
        <div class="clearfix">
          <div class="notice-mid-logo">
            <img src="../assets/home_icon04.png" class="titicon">
            <span>{{ classifyList[0].name }}</span>
          </div>
          <div class="notice-mid-title" v-for="item, index in noticeList" :key="index" @click="goNewsDetail(item.id)">
            <a class="title-text">{{ item.title }}</a>
            <p class="title-time">时间:{{ item.publishTime | dateFormat }}</p>
          </div>
        </div>
        <div class="notice-information">
          <div class="information">
            <div class="information-news">
              <img src="../assets/home_icon05.png" class="news">{{ classifyList[1].name }}
              <span @click="goNews(classifyList[1], 1)" class="more cpointer">更多 ></span>
            </div>
            <template>
              <div class="information-list" v-for="item, index in newsList" :key="index" @click="goNewsDetail(item.id)">
                <span class="information-serial">{{ index + 1 }}</span>
                <a class="information-content">{{ item.title }}</a>
              </div>
            </template>
          </div>
          <div class="information">
            <div class="information-news">
              <img src="../assets/home_icon06.png" class="news">{{ classifyList[2].name }}
              <a @click="goNews(classifyList[2], 2)" class="more cpointer">更多 ></a>
            </div>
            <template>
              <div class="information-list" v-for="item, index in hotList" :key="index" @click="goNewsDetail(item.id)">
                <span class="information-serial">{{ index + 1 }}</span>
                <a class="information-content">{{ item.title }}</a>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="login-order">
      <div class="order-mid">
        <div class="order-title">
          <img src="../assets/home_icon07.png" class="order-icon">报考学习流程
        </div>
        <div class="order-chart">
          <div class="lcconTop">
            <img src="../assets/home_icon08.png">
            <p style="color: #a9a9a9;">成人高考</p>
            <img src="../assets/home_icon10.png">
            <p style="color: #3a77a8;">学籍办理</p>
            <img src="../assets/home_icon12.png">
            <p style="color: #ffa400;">学期考试</p>
            <img src="../assets/home_icon14.png">
            <p style="color: #a9a9a9;">论文答辩</p>
            <img src="../assets/home_icon16.png">
          </div>
          <div class="lcconMiddle">
            <div class="lcconMiddleCircle1"></div>
            <div class="lcconMiddleCircle2"></div>
            <div class="lcconMiddleCircle3"></div>
            <div class="lcconMiddleCircle4"></div>
            <div class="lcconMiddleCircle5"></div>
            <div class="lcconMiddleCircle6"></div>
            <div class="lcconMiddleCircle7"></div>
            <div class="lcconMiddleCircle8"></div>
            <div class="lcconMiddleCircle9"></div>
            <div class="lcconMiddleLine"></div>
          </div>
          <div class="lcconBottom">
            <p style="color: #3a77a8;">报名咨询</p>
            <img src="../assets/home_icon09.png">
            <p style="color: #ffa400;">录取查询</p>
            <img src="../assets/home_icon11.png">
            <p style="color: #a9a9a9;">日常学习</p>
            <img src="../assets/home_icon13.png">
            <p style="color: #3a77a8;">毕业登记</p>
            <img src="../assets/home_icon15.png">
            <p style="color: #ffa400;">学位申请</p>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <select-major ref="SelectMajor"></select-major>
    <el-dialog title="密码重置" :visible.sync="dialogVisible" @close="closeDialog">
      <el-form label-width="auto" :model="formData" ref="formData" v-loading="loading" :rules="rules">
        <el-form-item label="验证手机号" prop="phone">
          <el-input v-model="formData.phone" placeholder="验证手机号" clearable></el-input>
        </el-form-item>
        <el-form-item label="图形验证码" prop="photoCode">
          <el-input v-model="formData.photoCode" placeholder="请输入图形验证码" clearable style="width: 70%;"
                    class="mr-2"/>
          <img :src="verificationImageUrl" alt="" @click="verificationCode" style="cursor: pointer; width: 100px;">
        </el-form-item>
        <el-form-item label="短信验证码" prop="checkcode">
          <el-input v-model="formData.checkcode" placeholder="请输入短信验证码" clearable style="width: 70%;"
                    class="mr-2"/>
          <div style="cursor: pointer;display: inline-block;">
            <el-button type="primary" v-if="smsSecond == 0" @click="handleSendSms">获取验证码</el-button>
            <el-button type="primary" v-else>{{ `${smsSecond}秒后重发` }}</el-button>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit" :disabled="loading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import vueQr from "vue-qr";
import SelectMajor from "@/components/SelectMajor";
import HeaderTop from "@/components/HeaderTop.vue";
import Footer from "@/components/Footer.vue";
import {dologin} from "@/api";

export default {
  name: 'Login',
  components: {
    vueQr,
    SelectMajor,
    HeaderTop,
    Footer
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      verificationImageUrl: null,
      intervalTime: null,
      smsSecond: 0,
      formData: {
        randomStr: null,
        phone: null,
        photoCode: null,
        checkcode: null,
      },
      rules: {
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {validator: this.validatePhone, trigger: 'blur'},
        ],
        photoCode: [{required: true, message: '请输入图形验证码'},],
        checkcode: [{required: true, message: '请输入短信验证码'},],
      },
      form: {
        username: null,
        password: null,
      },
      user: undefined,
      activeIndex: 'Login',
      is_login: true, // 是否首页
      type: 0,
      // 公告分类列表
      classifyList: [
        {
          id: '',
          name: ''
        },
        {
          id: '',
          name: ''
        },
        {
          id: '',
          name: ''
        }
      ],
      // 新闻列表
      newsList: [],
      // 最热列表
      hotList: [],
      // 公告列表
      noticeList: []
    };
  },
  created() {
    document.title = '成人教育管理平台';
  },
  mounted() {
    this.getClassify()
  },
  destroyed() {
    if (this.intervalTime) {
      clearInterval(this.intervalTime);
    }
  },
  methods: {
    urlToObj (url) {
      let obj = {};
      if (url.indexOf('?') >= 0) {
          let str = url.slice(url.indexOf('?') + 1);
          let arr = str.split('&');
          console.log(str, arr)
  
          for (let j = arr.length, i = 0; i < j; i++) {
          let arr_temp = arr[i].split('=');
          obj[arr_temp[0]] = arr_temp[1];
          }
      }
      return obj;
    },
    /**
     * 校验手机号
     */
    validatePhone(rule, value, callback) {
      var isPhone = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
      // if (value.indexOf('****') >= 0) {
      //   return callback();
      // }
      if (!isPhone.test(value)) {
        callback(new Error('请输入合法手机号'));
      } else {
        callback();
      }
    },
    /**
     *  发送验证码
     */
    async handleSendSms() {
      if (!this.formData.phone) {
        this.$bvToast.toast("请输入手机号", {
          title: "提示",
          variant: "danger",
          solid: true,
        });
        return
      }

      this.$refs.formData.validateField(['phone'], async (valid) => {
        if (valid) {
          this.$bvToast.toast("请输入合法手机号", {
            title: "提示",
            variant: "danger",
            solid: true,
          });
          return
        }
        if (!this.formData.photoCode) {
          this.$bvToast.toast("请输入图形验证码", {
            title: "提示",
            variant: "danger",
            solid: true,
          });
          return
        }
        try {
          this.loading = true;
          await this.axios.post('/student/sendCheckCode1', {
            phone: this.formData.phone,
            photoCode: this.formData.photoCode,
            randomStr: this.formData.randomStr,
          }).then(() => {
            this.$bvToast.toast("短信发送成功", {
              title: "提示",
              variant: "success",
              solid: true,
            });
            if (this.intervalTime) {
              this.intervalTime = null
            }
            this.smsSecond = 90
            this.intervalTime = setInterval(() => {
              if (this.smsSecond === 0) {
                clearInterval(this.intervalTime)
              } else {
                this.smsSecond--
              }
            }, 1000)
          })
        } finally {
          this.loading = false;
        }
      })
    },
    // 图形验证码
    verificationCode() {
      this.formData.randomStr = new Date().getTime();
      this.verificationImageUrl = process.env.VUE_APP_BASE_URL + `/comm/verification/code?randomStr=` + this.formData.randomStr;
    },
    onSubmit() {
      this.$refs.formData.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true;
            let params = {
              phone: this.formData.phone,
              checkcode: this.formData.checkcode,
            }
            await this.axios.put("/student/setPhoneAndFindPassword", {...params}).then(res => {
              this.$bvToast.toast('操作成功', {
                title: "提示",
                variant: "success",
                solid: true,
              });
              this.dialogVisible = false;
            })
          } finally {
            this.loading = false;
          }
        }
      });
    },
    closeDialog() {
      Object.keys(this.formData).forEach((item) => {
        this.formData[item] = null;
      });
      this.$nextTick(() => {
        this.$refs.formData.resetFields();
      })
    },
    // 学生登录
    async stuLogin() {
      if (!this.form.username) {
        this.$bvToast.toast("用户名不能为空", {
          title: "提示",
          variant: "danger",
          solid: true,
        });
        return;
      }
      if (!this.form.password) {
        this.$bvToast.toast("密码不能为空", {
          title: "提示",
          variant: "danger",
          solid: true,
        });
        return;
      }
      this.loading = true;
      dologin(this.form).then(async (res1) => {
        const res = await this.axios.post("/student/login");
        this.user = res.data;
        this.$store.commit("LOGIN", this.user);
        const info = await this.axios.get("/student/info");
        if (info.data.length > 0) {
          this.$store.commit("LOGINBAK", info.data);
          if (info.data && info.data.length > 1) {
            this.$refs.SelectMajor.open((e) => {
              this.goHome(e);
            }, true);
          } else {
            this.goHome(info.data[0]);
          }
        } else {
          this.$router.push({path: "/main/readyExam"});
        }
      }).catch((err) => {
        // this.$bvToast.toast("登陆失败，用户名或密码错误", {
        //   title: "提示",
        //   variant: "danger",
        //   solid: true,
        // });
      });
      this.loading = false;

    },
    // // 管理员登录
    // async admLogin() {
    //   if (!this.form.username) {
    //     this.$bvToast.toast("用户名不能为空", {
    //       title: "提示",
    //       variant: "danger",
    //       solid: true,
    //     });
    //     return;
    //   }
    //   if (!this.form.password) {
    //     this.$bvToast.toast("密码不能为空", {
    //       title: "提示",
    //       variant: "danger",
    //       solid: true,
    //     });
    //     return;
    //   }
    //   await this.axios.post("/portal/admin/login", this.form)
    //     .then((res) => {
    //       let username = window.btoa(window.btoa(this.form.username)); // 编码
    //       let password = window.btoa(window.btoa(this.form.password)); // 编码
    //       window.location.href = `${process.env.VUE_APP_MANAGEMENT_SYSTEM}?u_=${username}&p_=${password}`
    //     })
    // },
    async goHome(user) {
      debugger
      this.user.regInfo = user;
      this.$store.commit("LOGIN", this.user);
      const params = {
        schoolId: user.schoolId,
      };
      const {data} = await this.axios.get("/comm/findSysConfig", {
        params,
      });
      this.$store.commit("SYSCONFIG", data);
      this.$router.push({path: "/main/home"});
    },
    // 公告分类列表
    async getClassify() {
      await this.axios.get("/portal/classify").then((res) => {
        this.classifyList = res.data
      })
      this.getNotice()
      this.getNews()
      this.getHot()
    },
    // 新闻资讯列表
    async getNews() {
      let params = {
        classifyId: this.classifyList[1].id,
        page: 1,
        pageSize: 5
      }
      await this.axios.get('/portal/notice', {params}).then((res) => {
        this.newsList = res.data
      })
    },
    // 最热资讯列表
    async getHot() {
      let params = {
        classifyId: this.classifyList[2].id,
        page: 1,
        pageSize: 5
      }
      await this.axios.get('/portal/notice', {params}).then((res) => {
        this.hotList = res.data
      })
    },
    // 通知公告
    async getNotice() {
      let params = {
        classifyId: this.classifyList[0].id,
        page: 1,
        pageSize: 1
      }
      await this.axios.get('/portal/notice', {params}).then((res) => {
        this.noticeList = res.data
      })
    },
    typeChange(type) {
      this.type = type
      this.form = {
        username: null,
        password: null,
      }
    },
    dologin() {
      if (this.type == 1) {
        this.admLogin()
      } else {
        this.stuLogin()
      }
    },
    goNews(item, index) {
      this.$router.push({name: 'News', query: {item, index}})
    },
    goNewsDetail(id) {
      this.$router.push({name: "NewsDetail", query: {id}});
    }
  },
};
</script>

<style lang="scss" scoped>
.form-item-text {
  width: 100px;
}

.login {
  .login-bannerbox {
    .loginBox {
      .loginBox-loginbtn {
        background-color: #3a77a8;
        border-radius: 5px;
        width: 100%;
        height: 38px;
        border: none;
        outline: none;
        cursor: pointer;
        color: #ffffff;
        font-size: 14px;
        margin-bottom: 20px;
      }

      .password-retrieve {
        font-size: 13px;
        cursor: pointer;
        line-height: 30px;
        text-align: center;
        color: #005599;
      }
    }
  }

  .loging-notice {
    padding: 30px 0 20px 0;

    .notice-mid {
      width: 1200px;
      margin: 0 auto;

      .notice-mid-logo {
        background: url('../assets/home_icon03.png') no-repeat;
        width: 342px;
        height: 86px;
        background-size: 100% 100%;
        box-sizing: border-box;
        padding-left: 70px;
        float: left;
        font-size: 24px;
        line-height: 86px;
        color: #ffffff;

        img {
          width: 30px;
          height: 30px;
          vertical-align: text-bottom;
          margin-right: 15px;
        }
      }

      .notice-mid-title {
        border-left: 5px solid #ffa400;
        padding: 15px 20px;
        background-color: #ffffff;
        box-shadow: 0px 0px 20px rgba(221, 221, 221, 0.6);
        height: 86px;
        box-sizing: border-box;
        float: left;
        width: 850px;
        margin-left: 8px;
        float: left;
        cursor: pointer;

        .title-text {
          font-size: 16px;
          line-height: 32px;
          color: #333333;
          display: block;
          font-weight: normal;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .title-text:hover {
          color: #1965a2;
        }

        .title-time {
          font-size: 13px;
          color: #666666;
          line-height: 24px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .notice-information {
      display: flex;
      flex-flow: row;
      justify-content: space-between;
      margin-top: 15px;

      .information {
        width: 590px;
        box-sizing: border-box;
        box-shadow: 0px 0px 20px rgba(221, 221, 221, 0.6);
        padding: 10px 30px;
        background-color: #ffffff;

        .information-news {
          font-size: 16px;
          color: #333333;
          line-height: 48px;
          margin-bottom: 15px;
          border-bottom: 1px solid #dddddd;

          .news {
            display: inline-block;
            vertical-align: middle;
            margin-bottom: 2px;
            margin-right: 10px;
          }

          .more {
            display: block;
            float: right;
            font-size: 14px;
            color: #999;
          }
        }

        .information-list:nth-child(4),
        .information-list:nth-child(2),
        .information-list:nth-child(3) {
          span {
            background-color: #1965a2;
            color: #ffffff;
          }
        }

        .information-list {
          padding: 5px;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          .information-serial {
            background-color: #dcdcdc;
            color: #999;
            width: 24px;
            height: 24px;
            text-align: center;
            line-height: 24px;
            font-size: 16px;
            margin-right: 10px;
            display: inline-block;
            border-radius: 50%;
          }

          .information-content {
            color: #333333;
            font-size: 16px;
            line-height: 36px;
            display: inline-block;
            cursor: pointer;
          }

          .information-content:hover {
            color: #1965a2;
          }
        }
      }
    }
  }

  .login-order {
    background-color: #ffffff;
    padding: 40px 0;

    .order-mid {
      width: 1200px;
      margin: 0 auto;

      .order-title {
        background-color: #d7e7f4;
        border-radius: 0px 40px 0px 0px;
        line-height: 56px;
        color: #3a77a8;
        font-size: 24px;
        font-weight: bold;
        padding: 0 50px 0 40px;
        display: inline-block;

        .order-icon {
          display: inline-block;
          width: 22px;
          vertical-align: middle;
          margin-bottom: 2px;
          margin-right: 10px;
        }
      }

      .order-chart {
        padding: 40px 50px;
        background-color: #d7e7f4;

        .lcconTop {
          display: flex;
          justify-content: space-between;

          p {
            margin: 0;
            width: 70px;
            height: 40px;
            margin-top: 38px;
            line-height: 40px;
            text-align: center;
            color: #ffffff;
            font-weight: bold;
          }
        }

        .lcconMiddle {
          height: 9px;
          background-color: #fff;
          margin: 20px 30px;
          position: relative;

          .lcconMiddleCircle1 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #3a77a8;
            border-radius: 50%;
            left: -0.4%;
            top: -4px;
          }

          .lcconMiddleCircle2 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #d9d9d9;
            border-radius: 50%;
            left: 12%;
            top: -4px;
          }

          .lcconMiddleCircle3 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #ffa400;
            border-radius: 50%;
            left: 24.4%;
            top: -4px;
          }

          .lcconMiddleCircle4 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #3a77a8;
            border-radius: 50%;
            left: 36.8%;
            top: -4px;
          }

          .lcconMiddleCircle5 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #d9d9d9;
            border-radius: 50%;
            left: 49.2%;
            top: -4px;
          }

          .lcconMiddleCircle6 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #ffa400;
            border-radius: 50%;
            left: 61.5%;
            top: -4px;
          }

          .lcconMiddleCircle7 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #3a77a8;
            border-radius: 50%;
            left: 74%;
            top: -4px;
          }

          .lcconMiddleCircle8 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #d9d9d9;
            border-radius: 50%;
            left: 86.3%;
            top: -4px;
          }

          .lcconMiddleCircle9 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #ffa400;
            border-radius: 50%;
            left: 98.7%;
            top: -4px;
          }

          .lcconMiddleLine {
            border-bottom: 1px dashed #d9d9d9;
            padding-top: 4px;
          }
        }

        .lcconBottom {
          display: flex;
          justify-content: space-between;

          p {
            margin: 0;
            width: 70px;
            height: 40px;
            margin-bottom: 38px;
            line-height: 40px;
            text-align: center;
            color: #ffffff;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
